import DashboardLayout from '@/components/Dashboard/Layout/DashboardLayout.vue'

import SchedPage from '@/pages/Sched/sched.vue'
import {RouteConfig} from 'vue-router'

// @ts-ignore
import messages from '@/lang/index'

const sched: RouteConfig = {
  path: '/schedule',
  name: 'schedule',
  meta: {
    pageName: messages.common.sidebar_links.schedule
  },
  component: DashboardLayout,
  redirect: '/schedule/list',
  children: [
    {
      path: 'list',
      name: 'schedPage',
      meta: {
        pageName: messages.schedule.list
      },
      component: SchedPage
    }
  ]
}

export default sched